export default __webpack_public_path__ + "static/media/no-results.7a251309.png";